import { Component, Inject, OnInit, Output, Input, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, Validators, FormControl } from '@angular/forms';
import { ActividadesService } from '../../../providers/actividades.service';
import { MatSnackBar } from '@angular/material';
import { TipoIncidenciaService } from '../../../providers/tipo-incidencia.service';
import { TipoIncidencia } from '../../../interfaces/tipo-incidencia';
import { WMatTimePickerComponent } from '../../timer/time-control';
import { Usuario, TipoUsuario } from '../../../interfaces/usuario';
import { Telefono } from '../../telefono/telefono.component';
import { UsuarioService } from '../../../providers/usuario.service';

export interface DialogData {
  campoModificar: string;
  titulo: string;
}

@Component({
  selector: 'app-acciones-actividad',
  templateUrl: './acciones-actividad.component.html',
  styleUrls: ['./acciones-actividad.component.scss']
})
export class AccionesActividadComponent {
  @Output() onCerrado = new EventEmitter();
  @Input() propuesta: any;
  @Input() entidad: any;
  @Input() cotizacion: any;
  @Input() actividad: any;
  @Input() agenda: any;

  opcionActividad: 'programada' | 'incidencia';
  public accion = 'CREAR';
  error: string = '';
  public actividades: any;
  public datosCargados: any;
  datos: any;

  notification: boolean = false;
  responsables = [];
  @ViewChild('descripcion') descripcion: ElementRef;
  btnDisabled: boolean = true;
  mensaje: boolean = false;
  cargando: boolean = true;
  editando: boolean = false;
  removable = true;
  form = this._formBuilder.group({
    titulo: [],
    descripcion: [],
    fechaTarea: [],
    horaTarea: [],
    horaNotificacion: [],
    fechaNotificacion: [],
    cotizacion: [],
    entidad: [],
    propuesta: [],
    tipoIncidencia: new FormControl(null, []),

    responsables: []
  });
  public tiposIncidencias = [];

  constructor(
    public dialog: MatDialog,
    private _formBuilder: FormBuilder,
    private _actividadesSv: ActividadesService,
    public snackBar: MatSnackBar,
  ) { }

  ngOnInit() {
    if (this.propuesta != undefined) {
      this.form.controls['propuesta'].setValue(this.propuesta);
    }

    if (this.entidad != undefined) {
      this.form.controls['entidad'].setValue(this.entidad);
    }

    if (this.cotizacion != undefined) {
      this.form.controls['cotizacion'].setValue(this.cotizacion);
    }

    if (this.actividad != undefined) {
      this.cargarEdicion(this.actividad);
    }
  }

  cargarEdicion(actividad) {
    this.editando = true;
    this.accion = 'MODIFICAR';
    this.form.controls['fechaTarea'].setValue(actividad['fechaTarea']);
    this.form.controls['fechaNotificacion'].setValue(actividad['fechaNotificacion']);
  }

  submitActividad() {
    this.error = '';
    try {
      this.actividades = {
        "actividad": this.form.getRawValue(),
        "idCliente": localStorage.getItem('idCliente')
      }
      if (this.form.valid) {
        this.cargando = true;
        this._actividadesSv.generarActividad(this.actividades).subscribe(
          respuesta => {
            if (respuesta.estado == 1) {
              this.snackBar.open(respuesta.mensaje, 'OK', { duration: 2750 });
              this.onCerrado.emit();
            } else {
              this.cargando = false;
              this.error = respuesta.mensaje;
            }
            this.limpialFormulario();
          },
          error => {
            this.cargando = false;
            this.error = error;
            this.limpialFormulario();
          });
      }
    } catch (error) {
      this.error = error;
      this.cargando = false;
      this.limpialFormulario();
    }
  }

  limpialFormulario() {
    this.form.controls['titulo'].setValue(null);
    this.form.controls['descripcion'].setValue(null);
    this.form.controls['fechaTarea'].setValue(null);
    this.form.controls['horaTarea'].setValue(null);
    this.form.controls['fechaNotificacion'].setValue(null);
    this.form.controls['tipoIncidencia'].setValue(null);
    this.form.controls['responsables'].setValue(null);
    this.btnDisabled = true;
  }

  onInputDescripcion(event) {
    if (this.agenda != undefined) {
      if (event.srcElement.value == "" || this.form.controls['fechaTarea'].value == null) {
        if (event.srcElement.value != "") {
          this.mensaje = true;
        } else {
          this.mensaje = false;
        }
        this.btnDisabled = true;
      } else {
        this.btnDisabled = false;
        this.mensaje = false;
      }
      //form.controls['fechaTarea'].value
    } else {
      if (event.srcElement.value == "") {
        this.btnDisabled = true;
      } else {
        this.btnDisabled = false;
        this.mensaje = false;
      }
    }
  }

  compareFn(x: TipoIncidencia, y: TipoIncidencia): boolean {
    return x && y ? x.id === y.id : x === y;
  }

  openDialog(campoModificar, titulo?, notification?, fecha?): void {


    const dialogRef = this.dialog.open(DialogAccionesActividad, {
      width: '30vw',
      data: { campoModificar, titulo, notification, fecha }
    });

    dialogRef.afterClosed().subscribe(resultado => {
      if (resultado) {
        // console.log('Aca Esta', resultado);
        if (resultado.titulo != null) {
          this.form.controls['titulo'].setValue(resultado['titulo']);
        }
        if (resultado.fechaTarea != null) {
          const fechaTarea = new Date(resultado['fechaTarea']);
          if (!isNaN(fechaTarea.getTime())) {
            // Ajuste de la fecha para la zona horaria local
            const localFechaTarea = new Date(fechaTarea.getTime() + (fechaTarea.getTimezoneOffset() * 60000));
            const year = localFechaTarea.getFullYear();
            const month = String(localFechaTarea.getMonth() + 1).padStart(2, '0'); // Los meses empiezan desde 0
            const day = String(localFechaTarea.getDate()).padStart(2, '0');
            const formattedDate = `${year}-${month}-${day}`;
            this.form.controls['fechaTarea'].setValue(formattedDate + ' ' + resultado["horaTarea"]);
          } else {
            console.error('Invalid date format');
          }
        }
        if (resultado.fechaNotificacion != null) {
          this.form.controls['fechaNotificacion'].setValue(resultado['fechaNotificacion'].format("YYYY-MM-DD") + ' ' + resultado["horaNotificacion"]);
        }
        if (resultado.tipoIncidencia != null) {
          this.form.controls['tipoIncidencia'].setValue(resultado['tipoIncidencia']);
        }
        if (resultado.responsables != null) {
          this.form.controls['responsables'].setValue(resultado['responsables'])
        }
        if (resultado.descripcion != null) {
          this.form.controls['descripcion'].setValue(resultado['descripcion'])
        }
      }
      if (this.agenda != undefined) {
        if (this.form.controls['fechaTarea'].value == "" || this.form.controls['fechaTarea'].value == null) {
          if (this.form.controls['fechaTarea'].value != "") {
            this.mensaje = true;
          } else {
            this.mensaje = false;
          }
          this.btnDisabled = true;
        } else {
          this.btnDisabled = false;
          this.mensaje = false;
        }
        //form.controls['fechaTarea'].value
      }
      if(resultado.titulo){
        // console.log('Resuktado', resultado);

        if(resultado != "cerrar"){
          //console.log(resultado,'res');
          this.submitActividad();
        }
      }
      
    });
  }

  remove(campo: string, indexArray?): void {
    if (campo == 'tarea') {
      this.form.controls['titulo'].setValue(null);
      this.form.controls['fechaTarea'].setValue(null);
      this.form.controls['fechaNotificacion'].setValue(null);
      if (this.agenda != undefined) {
        if (this.form.controls['fechaTarea'].value == "" || this.form.controls['fechaTarea'].value == null) {
          if (this.form.controls['fechaTarea'].value != "") {
            this.mensaje = true;
          } else {
            this.mensaje = false;
          }
          this.btnDisabled = true;
        } else {
          this.btnDisabled = false;
          this.mensaje = false;
        }
        //form.controls['fechaTarea'].value
      }
    }
    if (campo == 'incidencia') {
      this.form.controls['tipoIncidencia'].setValue(null);
    }
    if (campo == "responsable") {
      // Escondo el mat-chip
      document.getElementById("mat-chip-" + indexArray).style.display = "none";
      // Busco los responsables en el array y los elimino
      this.form.controls['responsables'].value.splice(indexArray, 1)
    }
  }
}

@Component({
  selector: 'dialog-acciones-actividad',
  templateUrl: 'dialog-acciones-actividad.html',
})

export class DialogAccionesActividad {

  form = this._formBuilder.group({
    titulo: [],
    fechaTarea: [],
    horaTarea: [],
    horaNotificacion:[],
    fechaNotificacion: [],
    tipoIncidencia: new FormControl(null, []),
    responsables: [],
    descripcion: []
  });
  public tiposIncidencias = [];
  usuarios: Usuario[] = [];
  grupos: any[] = [];
  tipoIncidencia: TipoIncidencia;
  btnModalDisabled: boolean = true;
  notification: boolean = false;
  @ViewChild('horaActividadInput') horaActividadInput: WMatTimePickerComponent;
  @ViewChild('horaNotificacionInput') horaNotificacionInput: WMatTimePickerComponent;

  constructor(
    private dialogRef: MatDialogRef<DialogAccionesActividad>,
    private _formBuilder: FormBuilder,
    public snackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private tipoIncidenciaService: TipoIncidenciaService,
    private usuarioService: UsuarioService
  ) { }

  onNoClick(): void {
    this.dialogRef.close('cerrar');
  }

  submitDatosExtra() {
    this.dialogRef.close(this.form.getRawValue());
  }

  ngOnInit() {
    this.traerResposables();
    this.getGrupos();
    
    this.form.controls['titulo'].setValue(this.data['titulo']);
    this.setFormattedDate();
    this.tipoIncidencia = new TipoIncidencia(); // crear una incidencia en blanco
    this.traerTiposIncidencias();
  }
  getGrupoValue(grupo){
    return grupo.id + "_g";
  }
  
  setFormattedDate(): void {
    const rawDate = this.data['fecha'];
    const formattedDate = this.formatDate(rawDate);
    this.form.controls['fechaTarea'].setValue(formattedDate);
  }

  formatDate(date: string): string {
    console.log('Aca esta la date', date);
    const [year, month, day] = date.split('-').map(Number);
    const formattedMonth = month.toString().padStart(2, '0');
    const formattedDay = day.toString().padStart(2, '0');
    return `${year}-${formattedMonth}-${formattedDay}`;
  }
  traerResposables() {
    this.usuarios = <Usuario[]>[];
    this.usuarioService.getUsuarios(
      {
        page: null,
        pageSize: null
      },
      {
        sort: 'nombre',
        order: null
      },
      {
        generico: null
      }
    ).subscribe(
      respuesta => {
        if (respuesta.estado == 1 && respuesta.data && respuesta.data.usuarios) {
          respuesta.data.usuarios.forEach(usuario => {
            this.usuarios.push(
              new Usuario(
                usuario.id,
                usuario.usuario,
                usuario.email,
                <TipoUsuario>{
                  id: usuario.tipoUsuario.id,
                  descripcion: usuario.tipoUsuario.descripcion
                },
                null,
                usuario.nombre,
                usuario.apellido,
                new Telefono(usuario.telefono.pais, usuario.telefono.area, usuario.telefono.numero),
                +usuario.estado,
                usuario.puesto,
                !!+usuario.editable,
                !!+usuario.eliminable
              )
            );
          });
        }
      });
  }
  

  onInput() {
    if (this.data["campoModificar"] != 'Tipo de actividad') {
      if (this.form.controls['titulo'].value == '' || this.form.controls['titulo'].value == null) {
        this.btnModalDisabled = true;
      } else {
        if (this.data["campoModificar"] == 'Fecha de actividad') {
          if (this.form.controls['fechaTarea'].value != '' && this.form.controls['fechaTarea'].value != null) {
            if (this.horaActividadInput.time != '' && this.horaActividadInput.time != undefined)
              this.form.addControl('horaActividad', this.form.controls['horaTarea'].value);
            this.btnModalDisabled = false;
          } else {
            this.btnModalDisabled = true;
          }
        }
        if (this.data["campoModificar"] == 'Fecha de notificación') {
          if (this.form.controls['fechaNotificacion'].value != '' && this.form.controls['fechaNotificacion'].value != null && this.horaNotificacionInput.time != '' && this.horaNotificacionInput.time != undefined) {
            // this.form.controls['horaNotificacion'].setValue(this.horaNotificacionInput.time + ":00");
            this.form.addControl('horaNotificacion', new FormControl(this.horaNotificacionInput.time + ":00"));
            this.btnModalDisabled = false;
          } else {
            this.btnModalDisabled = true;
          }
        }
      }
    } else {
      this.btnModalDisabled = false;
    }
  }

  traerTiposIncidencias(): void {
    this.tiposIncidencias = [];
    this.tipoIncidenciaService.getTiposIncidencia(
      {
        page: null,
        pageSize: null
      },
      {
        sort: 'descripcion',
        order: 'asc'
      },
      {
        generico: ''
      }
    ).subscribe(
      respuesta => {
        if (respuesta.estado == 1 && respuesta.data && respuesta.data.tiposIncidencia) {
          respuesta.data.tiposIncidencia.forEach((tipoIncidencia: any) => {
            if (tipoIncidencia.TipoIncidenciaAutomatica == 0) {
              this.tiposIncidencias.push(<TipoIncidencia>{
                id: tipoIncidencia.IdTipoIncidencia,
                descripcion: tipoIncidencia.TipoIncidenciaDesc
              });
            }
          });
        }
      },
      error => {

      }
    );
  }

  onInputTipo(event) {
    if (!event) {
      this.form.controls['tipoIncidencia'].setValue('');
    }
  }

  
  getGrupos(){
    this.usuarioService.getGrupos(
      {
        page: null,
        pageSize: null
      },
      {
        sort: null,
        order: null
      },
    ).subscribe(
      respuesta => {
        //console.log("grupos", respuesta);
        let grupos = [];
        respuesta.data.forEach(element => {
          grupos.push({
            id: element.id,
            descripcion: element.descripcion,
            cantidad_usuarios: element.cantidad,
            usuarios: element.usuarios
          })
        });
        this.grupos = grupos;
      },

      (err) => {

      }
    );
  }
}
